import { render, staticRenderFns } from "./RatingPreference.vue?vue&type=template&id=cefd843a&scoped=true"
import script from "./RatingPreference.vue?vue&type=script&lang=js"
export * from "./RatingPreference.vue?vue&type=script&lang=js"
import style0 from "./RatingPreference.vue?vue&type=style&index=0&id=cefd843a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefd843a",
  null
  
)

export default component.exports